import md5 from 'js-md5'
import message from '@/pages/hmt/reservation/official-site/components/message'
import { getToken, TOKEN_KEY } from '@/utils/cookie'

interface Data {
  [key: string]:
    | string
    | number
    | boolean
    | Data
    | Array<Data>
    | Array<string>
    | null
}

interface Response {
  code: number
  current_time: number
  message?: string
  data: any
}

interface ExtraParmas {
  [propsName: string]: any
}

const env = import.meta.env.MODE || ''

const request = (
  url: string,
  config: RequestInit & ExtraParmas = {}
): Promise<Response> => {
  // url = `${env.includes('hmt') ? '/hmt/official-site' : ''}${url}`
  const timestamp = Date.parse(`${new Date()}`) / 1000
  const key = 'de2d7b2864d3a6b88cb9318677c12f41'
  const sign = md5(`${timestamp}${key}`).toUpperCase()

  const realConfig: RequestInit & ExtraParmas = {
    headers: {
      timestamp: `${timestamp}`,
      sign,
      'content-type': 'application/json',
      Authorization: getToken(),
    },
    ...config,
  }

  return fetch(url, realConfig)
    .then((res: any) => res.json())
    .then((resJson: any) => {
      if (resJson.code !== 200 && resJson.code !== 0) {
        if (resJson?.message && !config?.extraParams?.forbid) {
          message.error({
            content: resJson?.message,
          })
        }
        throw resJson
      } else {
        return resJson
      }
    })
    .catch((err) => {
      if (!config?.extraParams?.forbid) {
        message.error({
          content: err?.message || '内部错误，请稍后重试',
        })
      }
      if (err?.code === 401) {
        // 处理token失效
        localStorage.removeItem(TOKEN_KEY)
        // window.location.reload()
      }
      console.error(err?.message || '内部错误，请稍后重试')
      throw err
    })
}

// GET请求
export const get = (
  url: string,
  data: Data = {},
  extraParams?: ExtraParmas
): Promise<Response> => {
  const keysArray = Object.keys(data)
  if (keysArray.length > 0) {
    url += '?'
    url += keysArray.map((key) => `${key}=${data[key]}`).join('&')
  }
  return request(url, { method: 'GET', extraParams })
}

// POST请求
export const post = (
  url: string,
  data: Data = {},
  extraParams?: ExtraParmas
): Promise<Response> => {
  return request(url, {
    body: JSON.stringify(data),
    method: 'POST',
    extraParams,
  })
}
